// Copyright The OpenTelemetry Authors
// SPDX-License-Identifier: Apache-2.0

import ApiGateway from './Api.gateway';

/**
 * Shared react-query options for the recommendations request.
 *
 * Used in two places that must resolve to the same cache entry:
 *  - AdProvider, to read and render the recommended product list.
 *  - The pages that render <Recommendations /> (product detail, checkout
 *    complete), which dispatch the fetch via queryClient.prefetchQuery
 *    immediately after their Faro user action so the request is captured
 *    inside that action's window.
 *
 * Keeping the queryKey and queryFn in one place guarantees the prefetch and
 * the read share a cache entry (the queryKey must match exactly).
 */
export const recommendationsQueryOptions = (productIds: string[], currencyCode: string) => ({
  queryKey: ['recommendations', productIds, 'selectedCurrency', currencyCode],
  queryFn: () => ApiGateway.listRecommendations(productIds, currencyCode),
});
